/* eslint-disable react/prop-types */
import React from 'react';
import { Tag } from 'antd';

export default function StageTagComponent({ stage }) {
  if (!stage) {
    return '-';
  }

  // Define os IDs dos estágios que devem ter texto branco
  const stagesWithWhiteText = [
    12, // Reservado
    14, // Aguardando Documentação
    15, // Faturado/Aguardando Documentação
    16, // Aguardando Faturamento
  ];

  // Define a cor do texto com base no ID do estágio
  const textColor = stagesWithWhiteText.includes(stage.id) ? '#fff' : '#121212';

  return (
    <Tag
      color={stage.color}
      style={{
        color: textColor,
        fontSize: 12,
        fontWeight: 600,
        borderRadius: 8,
        padding: 4,
        maxWidth: '100%',
        whiteSpace: 'normal',
        wordBreak: 'break-word',
      }}
    >
      {stage.name}
    </Tag>
  );
}
